import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { X } from "lucide-react";

export default function WhatsAppButton() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsub();
  }, []);

  if (!isLoggedIn) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div className="relative flex flex-col items-end space-y-3 animate-fade-in">
        {tooltipVisible && (
          <div className="relative bg-white shadow-2xl px-4 py-3 rounded-xl w-72 border border-gray-100">
            <div className="flex items-center gap-3">
              <img
                src="/equipo.png" // Asegúrate de tener esta imagen en public/
                alt="Soporte"
                className="w-10 h-10 rounded-full border object-cover bg-gray-100"
              />
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-900">Soporte Noltrade</p>
                <p className="text-sm text-gray-600 leading-tight mt-1">
                  ¿Tienes dudas? Estamos en WhatsApp para ayudarte 🙂
                </p>
              </div>
            </div>
            <button
              onClick={() => setTooltipVisible(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
            >
              <X size={16} />
            </button>
          </div>
        )}

        <a
          href="https://wa.me/34694204193"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chatea por WhatsApp"
          className="w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-xl transition-all duration-300 ease-in-out hover:shadow-2xl hover:scale-105"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            className="w-7 h-7"
            fill="currentColor"
          >
            <path d="M16.001 3.2A12.8 12.8 0 003.2 16c0 2.26.6 4.46 1.73 6.38L3.002 28.8l6.59-1.89A12.755 12.755 0 0016.001 28.8 12.8 12.8 0 0016 3.2zm0 23.36a10.62 10.62 0 01-5.41-1.48l-.39-.23-3.91 1.12 1.12-3.79-.25-.4a10.62 10.62 0 1119.03-5.26c0 5.87-4.78 10.64-10.62 10.64zm5.8-7.99c-.32-.16-1.88-.93-2.17-1.03s-.5-.16-.7.17c-.22.32-.85 1.03-1.04 1.25-.19.22-.38.24-.7.08-.32-.16-1.36-.5-2.6-1.6-.96-.86-1.6-1.92-1.78-2.24-.18-.32-.02-.5.14-.66.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.1-.22.05-.4-.02-.56-.08-.16-.7-1.67-.96-2.3-.25-.6-.5-.52-.7-.52h-.6c-.22 0-.56.08-.85.4s-1.12 1.1-1.12 2.7 1.14 3.13 1.3 3.34c.16.22 2.23 3.38 5.41 4.73.76.33 1.36.52 1.82.66.76.24 1.46.2 2.01.12.61-.09 1.88-.77 2.14-1.52.26-.76.26-1.41.18-1.54-.08-.13-.29-.21-.61-.36z" />
          </svg>
        </a>
      </div>
    </div>
  );
}
